import { cn } from '@web-app/lib/utils';
import * as React from 'react';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content min-h-16 w-full rounded-md border border-input-legacy bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground-legacy focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive-legacy aria-invalid:ring-destructive-legacy/20 md:text-sm dark:bg-input-legacy/30 dark:aria-invalid:ring-destructive-legacy/40',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
